import { IThereDirectionRes } from '../models';
import { $api } from '../service';

export const getThereDirection = async () => {
  const { data } = await $api.get<IThereDirectionRes>('/direction');

  return { thereDirection: data };
};
